import classNames from 'classnames';
import React from 'react';

export interface PageContentProps {
  children: React.ReactNode | React.ReactNode[];
  fullWidth?: boolean;
  halfWidth?: boolean;
}

const PageContent: React.FC<PageContentProps> = ({
  children,
  fullWidth = false,
  halfWidth = false
}: PageContentProps) => {
  return (
    <div
      className={classNames('mss-page__content', {
        'mss-page__content--full-width': fullWidth,
        'mss-page__content--half-width': halfWidth
      })}
    >
      {children}
    </div>
  );
};

export default PageContent;
